const taskNumberCollator = new Intl.Collator("en-AU", {
  numeric: true,
  sensitivity: "base",
});

export function compareTaskNumbers(left?: string | null, right?: string | null): number {
  return taskNumberCollator.compare(String(left || "").trim(), String(right || "").trim());
}
